import '@fontsource/playfair-display/700.css';
import '@fontsource/playfair-display/800.css';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { routeChunksSettled } from './lib/routeLazy';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Trigger the pre-render snapshot once React has rendered AND every lazily
// routed chunk for this URL has landed. Without the second condition the
// snapshot can catch a route mid-flight and persist an empty page.
const trigger = () => document.dispatchEvent(new Event('render-event'));
const snapshotWhenReady = () => {
  routeChunksSettled().then(() => {
    if (typeof window.requestIdleCallback === 'function') {
      // Дедлайн обязателен: на странице с большим числом внешних картинок
      // браузер не доходит до простоя, requestIdleCallback без timeout не
      // срабатывает вовсе, и пререндер падает по 30-секундному таймауту.
      window.requestIdleCallback(trigger, { timeout: 2000 });
    } else {
      setTimeout(trigger, 500);
    }
  });
};
// Two frames give React time to start the lazy factories before we check.
requestAnimationFrame(() => requestAnimationFrame(snapshotWhenReady));
